<script setup>
import { watch } from "vue";
import { useStore } from "@/store";
import { applyMobilePageStyle } from "@/utils/pageStyle";

const store = useStore();

applyMobilePageStyle(store.getPageStyle);

watch(
  () => store.getPageStyle,
  (pageStyle) => {
    applyMobilePageStyle(pageStyle);
  }
);
</script>

<template>
  <router-view />
</template>

<style lang="less">
@import "@/styles/securityBlue.less";

:root {
  --mobile-primary: #409eff;
  --mobile-primary-dark: #337ecc;
  --mobile-primary-light: #79bbff;
  --mobile-primary-soft: #ecf5ff;
  --mobile-accent: #409eff;
  --mobile-bg: #ffffff;
  --mobile-bg-accent: #f2f2f2;
  --mobile-card-bg: #ffffff;
  --mobile-border: #dcdfe6;
  --mobile-text: #2c3e50;
  --mobile-text-muted: #666666;
}

.mobile-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100vh;
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  background: var(--mobile-bg);
  color: var(--mobile-text);
}

html[data-page-style="army_green"] .mobile-container {
  background-color: var(--mobile-bg);
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='120' height='120' viewBox='0 0 120 120'%3E%3Cpath d='M0 15h15v15H0zm30 15h15v15H30zM0 45h15v15H0zm45 0h15v15H45zm30-30h15v15H75zm15-15h15v15H90zm15 30h15v15h-15zm-45 45h15v15H60z' fill='%23eaf2e9' fill-opacity='0.6'/%3E%3Cpath d='M15 0h15v15H15zm45 15h15v15H60zm15 30h15v15H75zM30 60h15v15H30zm60 15h15v15H90zm15-15h15v15h-15zm0-30h15v15h-15zm-45 60h15v15H60z' fill='%23dfebd9' fill-opacity='0.45'/%3E%3Cpath d='M0 75h15v15H0zm30 15h15v15H30zm45-15h15v15H75zm30 0h15v15h-15zm-30-30h15v15H75zM15 90h15v15H15zm75 15h15v15H90z' fill='%23d0e3ca' fill-opacity='0.3'/%3E%3C/svg%3E");
}

html[data-page-style="enterprise_blue"] .mobile-container {
  background-color: var(--mobile-bg);
}

html[data-page-style="civil_servant_red"] .mobile-container {
  background-color: var(--mobile-bg);
}

html[data-page-style="academy_blue"] .mobile-container {
  background-color: var(--mobile-bg);
}

html[data-page-style="security_blue"] .mobile-container {
  background-color: var(--mobile-bg);
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: var(--mobile-text);
}

.el-button--primary {
  --el-button-bg-color: var(--mobile-primary);
  --el-button-border-color: var(--mobile-primary);
  --el-button-hover-bg-color: var(--mobile-primary-light);
  --el-button-hover-border-color: var(--mobile-primary-light);
  --el-button-active-bg-color: var(--mobile-primary-dark);
  --el-button-active-border-color: var(--mobile-primary-dark);
}

.el-radio__input.is-checked .el-radio__inner,
.el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: var(--mobile-primary);
  border-color: var(--mobile-primary);
}

.el-radio__input.is-checked + .el-radio__label,
.el-checkbox__input.is-checked + .el-checkbox__label {
  color: var(--mobile-primary);
}

.no-wrap-message .el-message__content {
  min-width: 200px;
}

@media (min-width: 768px) {
  .answer_bottom {
    font-size: 16px !important;
    width: 100px;
    height: 40px !important;
  }
}
</style>
